import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '分类导航',
      links: [
        { href: '/category/dianying', label: '电影' },
        { href: '/category/dianshiju', label: '电视剧' },
        { href: '/category/zongyi', label: '综艺' },
        { href: '/category/dongman', label: '动漫' },
        { href: '/category/jilupian', label: '纪录片' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { href: '/article/1', label: '流浪地球3' },
        { href: '/article/2', label: '狂飙' },
        { href: '/article/3', label: '繁花' },
        { href: '/article/7', label: '乘风破浪的姐姐' },
        { href: '/article/8', label: '斗破苍穹' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { href: '/about', label: '品牌介绍' },
        { href: '/about', label: '联系我们' },
        { href: '/about', label: '用户口碑' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-900 text-secondary-100" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-white">
              51<span className="text-accent-400">视频</span>
            </Link>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              聚合香蕉视频、红桃视频、91视频等热门影视资源，提供最新电影、电视剧、综艺免费在线观看，高清不卡顿不缓冲，打造极致观影体验。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 51视频 版权所有 | 本站内容仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}